import PropTypes from "prop-types";
import classNames from "classnames";
import NextBtn from "../NextBtn/NextBtn";
import PrevBtn from "../PrevBtn/PrevBtn";
import classes from "./Navigation.module.css";

const Navigation = (props) => {
  const { className, onNext, onPrev } = props;

  return (
    <div className={classNames(classes["swiper-navigation"], className)}>
      <PrevBtn onClick={onPrev} />
      <NextBtn onClick={onNext} />
    </div>
  );
};

export default Navigation;

Navigation.propTypes = {
  classesName: PropTypes.string,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
};
